import {Grid} from "@material-ui/core";
import {Link} from "react-router-dom";
import React from "react";
import useStyles from "./useStyles";

const ModuleLink = (
    {
        to,
        children
    }
) => {

    const classes = useStyles();

    return <Link to={to}>
        <Grid xs={12}>
            <button className={"btn_1 btn--primary--solid--long"}>
                <Grid className={classes.paper}>
                    <a className={classes.whiteText}>{children}</a>
                </Grid>
            </button>
        </Grid>
    </Link>
};

export default ModuleLink;
